
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Alert,
} from "@mui/material";

const Back2WhatsAppDialog = ({ open, onClose, onConfirm }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>
        Falar no WhatsApp
      </DialogTitle>

      <DialogContent>
        <Alert severity="warning">
          Falar novamente pelo WhatsApp pode gerar custos
          adicionais para a sua empresa.
          <br />
          <br />
          Tem certeza de que deseja continuar com essa ação?
        </Alert>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} color="inherit">
          Não
        </Button>

        <Button onClick={onConfirm} variant="contained" color="success">
          Sim, continuar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default Back2WhatsAppDialog;